import { constants, Header, ProductNav } from '@redbubble/design-system';
import { onSearchCallback, onTypeaheadResultClick, } from '@redbubble/next-analytics/gtm';
import { RSLinkClickedLocation, useRudderstackClient, } from '@redbubble/next-provider/rudderstack';
import React from 'react';
import { trackGA4GlobalNavViewCategory, trackGA4GlobalNavViewSubCategory, } from '../analytics';
import { CartItemsCount } from '../cart-items-count';
var getPromoBannerHeight = function (bannerMessages, profile) {
    if (!bannerMessages || bannerMessages.length === 0)
        return 0;
    return profile === constants.DESKTOP ? 48 : 80;
};
export var AppHeader = function (_a) {
    // We have to determine device from the user-agent header and not viewport width
    // otherwise there can be mismatches between actual device type and that which would
    // be returned from useViewportWidth hook.
    // This is because when a client has a 768px viewport width doesnt mean it will be a tablet
    // when determined from useragent. iPads provide a desktop mac user-agent unless
    // specifically set otherwise.
    var headAndFooterVariant = _a.headAndFooterVariant, forceMobileHeader = _a.forceMobileHeader, intl = _a.intl, userInfo = _a.userInfo, globalNavigation = _a.globalNavigation, bannerMessages = _a.bannerMessages, deviceType = _a.deviceType, disableExpandedMobileSearch = _a.disableExpandedMobileSearch, disableStickySearch = _a.disableStickySearch, engagingPlaceholderMessages = _a.engagingPlaceholderMessages, searchTerm = _a.searchTerm, searchProductContext = _a.searchProductContext, type = _a.type, _b = _a.hideProductNavigation, hideProductNavigation = _b === void 0 ? false : _b, _c = _a.showAnimatedLogo, showAnimatedLogo = _c === void 0 ? true : _c, _d = _a.bannerInitialSeconds, bannerInitialSeconds = _d === void 0 ? 0 : _d;
    // TODO: Remove this as soon as possible we should not be rendering different components based on user-agent
    var shouldUseMobileHeader = deviceType === 'mobile' || deviceType === 'tablet' || forceMobileHeader;
    var renderProductNav = deviceType === 'desktop' && !hideProductNavigation;
    var profile = shouldUseMobileHeader ? constants.MOBILE : constants.DESKTOP;
    var showExpandedMobileSearch = !disableExpandedMobileSearch &&
        (deviceType === 'mobile' || deviceType === 'tablet');
    var headerPosition = !disableStickySearch ? 'fixed' : 'relative';
    var promoBannerHeight = getPromoBannerHeight(bannerMessages, profile);
    var RudderstackClient = useRudderstackClient().RudderstackClient;
    return (React.createElement("header", null,
        React.createElement(CartItemsCount, { initialCount: userInfo === null || userInfo === void 0 ? void 0 : userInfo.cartItems }, function (cart) { return (React.createElement("div", null,
            React.createElement(Header, { cart: cart, globalNavigation: globalNavigation, intl: intl, isServer: typeof window === 'undefined', profile: profile, userInfo: userInfo, useRainbowStyle: true, engagingPlaceholderMessages: engagingPlaceholderMessages, showExpandedMobileSearch: showExpandedMobileSearch, position: headerPosition, searchTerm: searchTerm, bannerMessages: bannerMessages, initialSeconds: bannerInitialSeconds, searchProductContext: searchProductContext, onTypeaheadResultClick: onTypeaheadResultClick, onSearchCallback: onSearchCallback, onNavItemClick: function (item, rootItem) {
                    trackGA4GlobalNavViewSubCategory(item, {
                        position: 'left_side',
                        parent: rootItem.label,
                    });
                    if (!RudderstackClient)
                        return;
                    RudderstackClient.linkClicked({
                        link_label: item.label,
                        location: RSLinkClickedLocation.NavSub,
                    });
                }, onNavItemView: function (item) {
                    return trackGA4GlobalNavViewCategory(item, {
                        position: 'left_side',
                    });
                }, type: type, showAnimatedLogo: showAnimatedLogo }))); }),
        renderProductNav && (React.createElement(ProductNav, { intl: intl, items: globalNavigation, peeking: true, promoBannerHeight: promoBannerHeight, onNavItemClick: function (item, rootItem) {
                trackGA4GlobalNavViewSubCategory(item, {
                    position: 'header',
                    parent: rootItem === null || rootItem === void 0 ? void 0 : rootItem.label,
                });
                if (!RudderstackClient)
                    return;
                RudderstackClient.linkClicked({
                    link_label: item.label,
                    location: RSLinkClickedLocation.NavSub,
                });
            } }))));
};
